import React from 'react'
import './ButtonOrder.css'

import { translate } from 'react-i18next'
import { Link } from 'react-router-dom'


const ButtonOrder = (props) => {
  return(
    <Link to="/order" className="bz"> {props.t('but2')} </Link>
  )
}

export default translate('translations')(ButtonOrder)


// WEBPACK FOOTER //
// ./src/components/ButtonOrder.jsx